import React from "react";
import { Modal, Input, Select, Button } from "antd";
import "./SingleSelectDropdownModal.css";

const { Option } = Select;

const SingleSelectDropdownModal = ({
    visible,
    onCancel,
    onSave,
    title,
    label,
    value,
    options = [],
    onChange,
    disabledInput = false,
    inputValue = "",
    inputLabel = "Item",
    secondaryInputValue,
    secondaryInputLabel,
    showProductSelect = false,
    allProducts = [],
    selectedProduct,
    setSelectedProduct,
}) => {
const isSaveDisabled = () => {
    if (showProductSelect && !selectedProduct) return true;
    if (!value) return true;
    return false;
};
return (
    <Modal
        title={title}
        open={visible}
        onCancel={onCancel}
        className="single-select-modal"
        footer={[
            <Button key="cancel" onClick={onCancel}>
            CANCEL
            </Button>,
            <Button key="save" type="primary" onClick={onSave} disabled={isSaveDisabled()}>
            SAVE
            </Button>,
        ]}
        >
        {showProductSelect ? (
            // Product selection for add mode
            <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 500 }}>Select Product:</label>
            <Select
                style={{ width: "100%", marginTop: 8 }}
                placeholder="Select a product"
                value={selectedProduct?.id}
                onChange={(value) => {
                const product = allProducts.find(p => p.id === value);
                setSelectedProduct(product);
                }}
                options={allProducts.map(product => ({
                value: product.id,
                label: product.name,
                }))}
            />
            </div>
        ) : disabledInput ? (
            // Product display for edit mode
            <>
            <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 500 }}>{inputLabel}</label>
                <Input value={inputValue} style={{ width: "100%", marginTop: 8 }} disabled />
            </div>
            {secondaryInputValue && (
                <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 500 }}>{secondaryInputLabel}</label>
                <Input value={secondaryInputValue} style={{ width: "100%", marginTop: 8 }} disabled />
                </div>
            )}
            </>
        ) : null}

        <div>
            <label style={{ fontWeight: 500 }}>{label}</label>
            <Select
            value={value}
            onChange={onChange}
            style={{ width: "100%", marginTop: 8 }}
            placeholder={`Select ${label}`}
            showSearch
            showArrow={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={showProductSelect && !selectedProduct}
            >
            {options.map((option) => (
                <Option key={option.value} value={option.value}>
                {option.label}
                </Option>
            ))}
            </Select>
        </div>
        </Modal>
    );
};

export default SingleSelectDropdownModal;